import React from "react";
import HtmlEditor from "../../componrnts/html-editor.tsx";

const inputClass =
  "w-full rounded-lg border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-100 outline-none transition focus:border-indigo-400";

export type PostFormState = {
  title: string;
  content: string;
  isPublished: boolean;
  thumbnailFile: File | null;
};

type Props = {
  title: string;
  content: string;
  isPublished: boolean;
  thumbnailFile: File | null;
  thumbnailPreviewUrl: string;
  thumbnailError?: string;
  mode: "create" | "edit";
  onTitleChange: (value: string) => void;
  onContentChange: (value: string) => void;
  onPublishedChange: (value: boolean) => void;
  onThumbnailChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export default function PostFormFields({
  title,
  content,
  isPublished,
  thumbnailPreviewUrl,
  thumbnailError,
  mode,
  onTitleChange,
  onContentChange,
  onPublishedChange,
  onThumbnailChange,
}: Props) {
  return (
    <>
      <label className="space-y-2 md:col-span-2">
        <span className="text-sm text-slate-300">عنوان</span>
        <input
          value={title}
          onChange={(e) => onTitleChange(e.target.value)}
          className={inputClass}
          placeholder="عنوان پست را وارد کنید..."
        />
      </label>

      <label className="flex items-center gap-2 md:col-span-2">
        <input
          type="checkbox"
          checked={isPublished}
          onChange={(e) => onPublishedChange(e.target.checked)}
          className="h-4 w-4 accent-indigo-500"
        />
        <span className="text-sm text-slate-300">منتشر شده</span>
      </label>

      <div className="space-y-2 md:col-span-2">
        <span className="text-sm text-slate-300">تصویر اصلی {mode === "create" ? "" : "(اختیاری)"}</span>
        <input
          type="file"
          accept="image/png,image/jpeg,image/webp,image/gif"
          onChange={onThumbnailChange}
          className="block w-full text-sm text-slate-300 file:me-3 file:rounded-lg file:border-0 file:bg-indigo-500 file:px-3 file:py-2 file:text-sm file:font-medium file:text-white hover:file:bg-indigo-400"
        />
        {thumbnailError ? <p className="text-xs text-rose-400">{thumbnailError}</p> : null}
        {thumbnailPreviewUrl ? (
          <img
            src={thumbnailPreviewUrl}
            alt="پیش‌نمایش تصویر اصلی"
            className="mt-2 h-40 w-full max-w-sm rounded-lg border border-slate-700 object-cover"
          />
        ) : null}
      </div>

      <div className="space-y-2 md:col-span-2">
        <span className="text-sm text-slate-300">محتوا</span>
        <HtmlEditor
          value={content}
          onChange={onContentChange}
          placeholder="محتوای پست را وارد کنید..."
          minHeight="320px"
        />
      </div>
    </>
  );
}

export function emptyPostForm(): PostFormState {
  return {
    title: "",
    content: "",
    isPublished: false,
    thumbnailFile: null,
  };
}

export function isPostFormValid(form: PostFormState, mode: "create" | "edit") {
  const hasTitle = Boolean(form.title.trim());
  const hasContent = Boolean(form.content.trim());
  if (mode === "create") {
    return hasTitle && hasContent && Boolean(form.thumbnailFile);
  }
  return hasTitle && hasContent;
}
